import { useEffect, useState } from "react";
import api, { fmtMoney, fmtDate } from "@/lib/api";
import { PageHeader, Loader, StatCard, EmptyState } from "@/components/ui-kit";
import { StatusBadge } from "@/components/StatusBadge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Wallet, Receipt, Landmark, ShieldCheck, CalendarClock, AlertTriangle, TrendingDown, Truck } from "lucide-react";

export default function Finance() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/finance/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <Loader />;

  return (
    <div>
      <PageHeader title="Finance / Compta" subtitle="Vue d'ensemble des charges, impôts, cotisations & trésorerie" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <StatCard label="Trésorerie" value={fmtMoney(d.tresorerie)} icon={Wallet} accent="emerald" hint="Solde total des caisses & comptes" />
        <StatCard label="Charges impayées" value={fmtMoney(d.charges_impayees)} icon={Receipt} accent="rose" hint={`Total charges ${fmtMoney(d.total_charges)}`} />
        <StatCard label="Impôts dus" value={fmtMoney(d.impots_dus)} icon={Landmark} accent="amber" hint={`Total ${fmtMoney(d.total_impots)}`} />
        <StatCard label="Cotisations dues" value={fmtMoney(d.cotisations_dues)} icon={ShieldCheck} accent="amber" hint={`Total ${fmtMoney(d.total_cotisations)}`} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard label="Dette fournisseurs" value={fmtMoney(d.dette_fournisseurs)} icon={Truck} accent="rose" hint={`Ce mois ${fmtMoney(d.fourn_mois)}`} />
        <StatCard label="À payer cette semaine" value={fmtMoney(d.du_semaine)} icon={CalendarClock} accent="blue" />
        <StatCard label="À payer ce mois" value={fmtMoney(d.du_mois)} icon={CalendarClock} accent="slate" />
        <StatCard label="En retard" value={fmtMoney(d.en_retard)} icon={AlertTriangle} accent="rose" />
      </div>

      <h3 className="font-head font-semibold text-lg mb-3 flex items-center gap-2"><TrendingDown className="h-5 w-5 text-brand-600" />Échéancier des dettes</h3>
      {(!d.echeances || d.echeances.length === 0) ? (
        <EmptyState icon={CalendarClock} title="Aucune échéance en attente" subtitle="Les charges, impôts et cotisations à régler apparaîtront ici." />
      ) : (
        <div className="rounded-xl border bg-white overflow-hidden"><div className="overflow-x-auto scrollbar-thin">
          <Table>
            <TableHeader><TableRow className="bg-slate-50"><TableHead>Type</TableHead><TableHead>N°</TableHead><TableHead>Libellé</TableHead><TableHead>Échéance</TableHead><TableHead className="text-right">Solde</TableHead><TableHead>État</TableHead></TableRow></TableHeader>
            <TableBody>
              {d.echeances.map((e, i) => (
                <TableRow key={i} className="hover:bg-slate-50" data-testid={`echeance-row-${i}`}>
                  <TableCell><span className="rounded bg-slate-100 px-2 py-0.5 text-xs">{e.type}</span></TableCell>
                  <TableCell className="font-mono text-xs text-slate-500">{e.numero}</TableCell>
                  <TableCell className="font-medium">{e.libelle}</TableCell>
                  <TableCell className="text-sm">{fmtDate(e.echeance)}</TableCell>
                  <TableCell className="text-right font-mono text-sm font-bold text-rose-600">{fmtMoney(e.solde)}</TableCell>
                  <TableCell><StatusBadge value={e.etat} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div></div>
      )}
    </div>
  );
}
